import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const OperatorHome = () => {
    return (
        <div className='flex gap-5'>
            <div className='bg-[#e7f7fe] w-[10%] h-[100vh] sticky left-0  flex flex-col gap-2 p-3'>
                <Link to="home"><p>Home</p></Link>
                <Link to="/operator/mybus"><p>My Buses</p></Link>
                <Link to="/operator/addbus"><p>Add New Bus</p></Link>
                <Link to="/operator/mybookings"><p>My Bookings</p></Link>
            </div>
            <Outlet/>
        </div>
    )
}

export default OperatorHome